import { buildSlice, CommonState } from '~libs/reduxUtils';

import { PricePlanRevision } from '~support-at-home/models';

import { create, getAll, getOne, typePrefix } from '~support-at-home/actions/pricePlanRevisions';

const initialState: CommonState<PricePlanRevision> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  row: undefined,
};

const slice = buildSlice<CommonState<PricePlanRevision>, PricePlanRevision>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
  extraReducers: (builder) => {
    builder.addCase(create.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.message = action.payload.message;
    });
  },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
